import React, { useState } from "react";
import styles from "./floating-input.module.css"; // You might need to adjust styles for the select dropdown

const FloatingLabelDropdown = ({
  label,
  value,
  setValue,
  options,
  isDisabled = false
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(value !== "");
  const handleChange = (e) => setValue(e.target.value);

  return (
    <div className={styles.inputWrapper}>
      <label
        className={`${styles.floatingLabel} ${
        isFocused || value ? styles.focused : ""}`
        }>

        {label}
      </label>
      <select
        className={styles["text-input"]} // You might need to adjust or add new styles for the select
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
        disabled={isDisabled}>

        {/* <option value="">Select Grade</option> */}
        {options.map((option) =>
        <option key={option.value} value={option.value}>
            {option.label}
          </option>
        )}
      </select>
    </div>);

};

export default FloatingLabelDropdown;